import React from 'react';
import { Button } from '@crisellevaldez/speculo-ui';
import { InfoNotice } from './InfoNotice';
import { DnsRecordsTable } from './DnsRecordsTable';
import { getEmailDnsRecords } from '../utils/emailDnsRecords';

interface EmailDnsRecordsProps {
  /** Domain the client picked for Remi's email. */
  domain: string;
  /** Domain the shown records were generated for, if any. */
  generatedFor?: string;
  onGenerate: () => void;
}

/** Option A of Remi Email Domain Setup: the DNS records the client adds themselves. */
export const EmailDnsRecords: React.FC<EmailDnsRecordsProps> = ({
  domain,
  generatedFor,
  onGenerate,
}) => {
  if (!domain) {
    return (
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Choose your email domain above to generate the DNS records.
      </p>
    );
  }

  // Records belong to one domain; changing the domain asks for new ones.
  if (generatedFor !== domain) {
    return (
      <div className="space-y-2">
        {generatedFor && (
          <p className="text-sm text-amber-700 dark:text-amber-400">
            Your domain changed. Generate new DNS records for {domain}.
          </p>
        )}
        <Button type="button" variant="primary" size="sm" onClick={onGenerate}>
          Generate DNS Records
        </Button>
      </div>
    );
  }

  const records = getEmailDnsRecords(domain);

  return (
    <div className="space-y-3">
      <InfoNotice>
        Add these records at your domain provider. Some providers add your domain to the host
        automatically. If yours does, enter only the part before <strong>{domain}</strong> (for
        example <code>{records[0].hostPrefix}</code>). Changes can take up to 24 hours to apply.
      </InfoNotice>
      <DnsRecordsTable records={records} />
    </div>
  );
};
